import { render, staticRenderFns } from "./ResponsiveAvatar.vue?vue&type=template&id=3c56779f&"
import script from "./ResponsiveAvatar.vue?vue&type=script&lang=js&"
export * from "./ResponsiveAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ResponsiveAvatar.vue"
export default component.exports